.amenityPaper {
    margin: 1em;
}
